import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private settings: any;

  constructor() {
    //在main.ts中已经将配置文件加载到全局变量APP_CONFIG中
    this.settings = window['APP_CONFIG'] || {};
  }

  /**
   * 读取JSON中指定键值
   */
  getSettings<T = any>(key?: string | Array<string>, defaultValue?: any): T {
    if (!key || (Array.isArray(key) && !key[0])) {
      return this.settings;
    }

    const paths = !Array.isArray(key) ? key.split('.') : key;

    let result = paths.reduce(
      (acc: any, current: string) => acc && acc[current],
      this.settings
    );

    if (result === undefined) {
      result = defaultValue;

      if (result === undefined) {
        throw new Error(
          `No setting found with the specified key [${paths.join('/')}]!`
        );
      }
    }

    return result;
  }
}
